import { showLoading, hideLoading } from 'react-redux-loading-bar'
import TeachersActions from './actions'
import request from './../../utils/requestConfig'

export default class TeachersMiddleware {
  static fetchTeachers () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      dispatch(showLoading())
      dispatch(TeachersActions.fetchTeachersRequest())
      request.get(`/school_adoptions/users?school_unit_ids=${currentItem.item.value}`)
        .then(({data}) => {
          dispatch(TeachersActions.fetchTeachersSuccess({data: data.data}))
          dispatch(hideLoading())
        })
        .catch((error) => (
          dispatch(TeachersActions.fetchTeachersError(error))
        ))
    }
  }
  static confirmTeacherAccount (id) {
    return (dispatch) => {
      dispatch(TeachersActions.confirmTeacherAccountRequest())
      request.post(`/potential_teachers/${id}/validate`)
        .then(() => {
          dispatch(TeachersActions.confirmTeacherAccountSuccess({id}))
          // dispatch(TeachersMiddleware.fetchTeachers())
        })
        .catch((error) => (
          dispatch(TeachersActions.confirmTeacherAccountError(error))
        ))
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/teachers/middleware.js